import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=69527a69&scoped=true&"
import script from "./Education.vue?vue&type=script&lang=js&"
export * from "./Education.vue?vue&type=script&lang=js&"
import style0 from "../index.scss?vue&type=style&index=0&id=69527a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69527a69",
  null
  
)

export default component.exports